<div class="container maintain-tab-header">
  <h1 class="menu-item-header" id="intro">Welcome to SoftDiamond

  </h1>
  <hr>
  <p>
    You are logged in as <b>{{ userName }}</b>. Testing New Branch.
  </p>
  <p>
    You are connected to the database with no error reported.
  </p>
  <p>
    Please use the menu to the left to proceed.
  </p>

  <p>
    <button style="float: none;" type="button" mat-raised-button (click)="dbBackup()" hidden="true"
                            color="warn">Database Backup</button>
  </p>
</div>
